<template>
    <div class="homepage">
        <ShopsGrid v-if="isEcommercePlatform" location="Homepage Grid"/>
        <div v-else>
            <div data-name="featured-campaigns">
                <!-- <ReferralBanner /> -->
                <div class="container featured-holder">
                    <div class="row">
                        <div class="col-12">
                            <FeaturedCampaigns/>
                            <Recommendations v-if="inPremium && publishedCampaignIds && publishedCampaignIds.length"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cardfilter">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <p>Find Your Matching Campaign</p>
                            <CardFilter />
                        </div>
                    </div>
                </div>
            </div>
            <SearchResult />
        </div>
    </div>
</template>

<script>
import {
    mapState,
    mapGetters
} from 'vuex';
import CardFilter from '@/components/CardFilter.vue';
import SearchResult from "@/components/AdvancedSearch/SearchResult";
import Heading from '@/components/Heading'
import FeaturedCampaigns from '@/components/FeaturedCampaigns'
import SendMessageModal from '../popups/SendMessageModal'
import ShopsGrid from '../components/Ecommerce/Shops'
import {message} from 'ant-design-vue'
// import ReferralBanner from '../components/ReferralBanner'
import Recommendations from '@/components/Recommendations'
export default {
    name: "Homepage",
    components: {
        CardFilter,
        SearchResult,
        Heading,
        FeaturedCampaigns,
        Recommendations,
        SendMessageModal,
        ShopsGrid,
        // ReferralBanner
    },
    mounted(){
        if(this.isEcommercePlatform && !this.myShops.length){
            message.info("You haven't added a shop yet. Use our wizard to add your shop via URL.", 5)
            return this.$router.push('/add-shop')
        }
    },
    computed: {
        ...mapState([
            'user',
            'publishedCampaignIds',
            'myShops'
        ]),
        ...mapGetters([
            'membershipStatus',
            'isEcommercePlatform',
            'inPremium'
        ])
    },
    data() {
        return {
            cardsList: [],
            swiperOption: {
                slidesPerView: 3,
                spaceBetween: 10,
                autoplay: { delay: 5000 },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
            }
        }
    },
}
</script>

<style scoped lang="scss">
@import '../assets/scss/variables.scss';
div[data-name="featured-campaigns"] {
    background: #D6DDE3;
}
.cardfilter {
    padding-top: 50px;
    p {
        color: $c6;
        font-size: $h4;
        font-weight: $weight_bold;
    }
}
.featured-holder {
    padding-top: 40px;
}

.refer-icon {
    position: fixed;
    right: 80px;
    top: 140px;
    min-width: 94px;
    z-index: 1000;
}
.seeMore {
    button {
        color: #FFFFFF;
        background: #727CF5;
        border-radius: 5px;
        width: 150px;
        height: 53px;
        margin-top: 90px;

        &:hover {
            /*margin-top: 87px;*/
            box-shadow: 0px 4px 8px rgba(114, 124, 245, 0.45);
        }
    }
}

@media only screen and (min-width: 280px) and (max-width: 450px) {
    .cards .col-12 {
        padding: 0;
    }
}
</style>